import { FileModel, Page, QueryBase } from "../../shared/models/models";

export interface Product {
  id: string;
  createdDate: Date;
  modifiedDate: Date;
  number: string;
  alternativeNumber?: string;
  name: string;
  description: string;
  height: number;
  width: number;
  depth: number;
  weight: number;
  file: FileModel | null;
  category: Category;
  manufacturer: Manufacturer;
}

export interface ChangeProduct {
  categoryId: string;
  manufacturerId: string;
  number: string;
  alternativeNumber?: string;
  description?: string;
  height?: number;
  width?: number;
  depth?: number;
  weight?: number;
  file?: FileModel | null;
}

export interface AdminProductsState {
  query: ProductsQuery;
  products?: Page<Product>;
  product?: Product;
  manufacturers?: Manufacturer[];
  categories?: Category[];
  loading: boolean;
  success?: string;
  error: any;
  fileResult?: FileResult;
}

export interface Category {
  id: string;
  parentId: string;
  name: string;
}

export interface ChangeCategory {
  parentCategoryId: string;
  name: string;
}

export interface Manufacturer {
  id: string;
  name: string;
}

export interface ChangeManufacturer {
  name: string;
}

export interface ProductsQuery extends QueryBase<ProductsQueryParameter> {
}

export enum ProductsQueryParameter {
  Name = 1,
  Number = 2,
  CreatedDate = 3,
  ModifiedDate = 4
}

export interface FileResult {
  messages: FileUploadResultMessage[];
  processedCount: number;
}

export interface FileUploadResultMessage {
  text: string;
  severityCode: SeverityCode;
}

export enum SeverityCode {
  error = 0,
  warning = 1
}

